import axios from 'axios';

const root = process.env.REACT_APP_API_URL
  ?? (process.env.NODE_ENV === 'production' ? 'https://api.tap2serve.co.za' : 'http://localhost:8080');

/** Admin-only endpoints — /api/admin/** */
const API = axios.create({ baseURL: `${root}/api/admin`, timeout: 15000 });
export default API;

/** Public / non-admin endpoints — /api/** (e.g. dispatch, services) */
export const publicApi = axios.create({ baseURL: `${root}/api`, timeout: 15000 });
